export default {

    formatCurrency(amount) {
        return Intl.NumberFormat("es-GT", {
            style: "currency",
            currency: "GTQ",
        }).format(amount);
    }

}